import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Known defect in Angular causes errors returned as json to be typed as Blob,
 * rendering them effectively useless.  Solution implemented here is temporary,
 * and can be removed once the referenced issue below has been fixed.
 * 
 * Issue:
 * https://github.com/angular/angular/issues/19888
 * 
 * Solution:
 * https://github.com/angular/angular/issues/19888#issuecomment-349650709
 */
@Injectable()
export class BlobErrorHttpService implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler):  Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            catchError(httpError => {
                if (httpError instanceof HttpErrorResponse && httpError.error instanceof Blob && httpError.error.type.startsWith("application/json")) {
                    return new Promise<any>((resolve, reject) => {
                        let reader = new FileReader();
                        reader.onload = (e: Event) => {
                            try {
                                const errmsg = JSON.parse((<any>e.target).result);
                                const parsed = { ...httpError, error: errmsg };
                                // If it was parsed, pass out the parsed error
                                reject(parsed);
                            } catch (e) {
                                // Otherwise, send the error we got back out
                                reject(httpError);
                            }
                        };
                        reader.onerror = (e: any) => {
                            // Something went wrong reading the blob field, return the original error
                            reject(httpError);
                        };
                        reader.readAsText(httpError.error);
                    });
                }
                return throwError(() => httpError);
            })
        );
    }
}
